export default {
  namespaced: true,

  state: {
    showPopupEmptyLesson: false,
    showPopupSimpleLesson: false,
    popupSlot: null
  },

  getters: {
    getShowPopupEmptyLesson: state => state.showPopupEmptyLesson,
    getShowPopupSimpleLesson: state => state.showPopupSimpleLesson,
    getPopupSlot: state => state.popupSlot
  },

  mutations: {
    SET(state, [namespace, data]) {
      state[namespace] = data;
    }
  },

  actions: {}
};
